export enum SettingsKeys {
    DefaultCardPermanentCancellationFeeSettingsKey = "default_card_permanent_cancellation_fee"
}
